import { defaultState } from "@/shared/utilities/constants";

export default () => ({
  users: { ...defaultState },
});
